import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Grid, { GridSpacing } from '@material-ui/core/Grid';

import { useTranslation } from 'react-i18next';
import { ConanairManagementStyle } from './ConanairManagementStyle';

type Props = {
  onClickSaveButton: () => void;
  onClickNewButton: () => void;
  onClickCancelButton: () => void;
  onClickDelButton: () => void;
  buttonEnable: boolean;
};

const ConanairManagementFooter: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const pageStyle = ConanairManagementStyle();
  return (
    <Grid
      container
      justify="flex-start"
      spacing={1}
      direction="row"
      alignItems="center"
      style={{ width: 'calc(100vw - 12px)' }}
    >
      <Grid item xs={2}>
        <Button
          className={pageStyle.buttonStyle}
          variant="contained"
          color="primary"
          disabled={!props.buttonEnable}
          disableElevation
          onClick={(e) => {
            props.onClickNewButton();
          }}
        >
          {t('ConanairManagementFooter.新規登録', '新規登録')}
        </Button>
      </Grid>
      <Grid item xs={2}>
        <Button
          className={pageStyle.buttonStyle}
          variant="contained"
          color="primary"
          disabled={!props.buttonEnable}
          disableElevation
          onClick={(e) => {
            props.onClickSaveButton();
          }}
        >
          {t('ConanairManagementFooter.保存', '保存')}
        </Button>
      </Grid>
      <Grid item xs={2}>
        <Button
          className={pageStyle.buttonStyle}
          variant="contained"
          color="primary"
          disabled={!props.buttonEnable}
          disableElevation
          onClick={(e) => {
            props.onClickCancelButton();
          }}
        >
          {t('ConanairManagementFooter.中止', '中止')}
        </Button>
      </Grid>
      <Grid item xs={2}>
        <Button
          className={pageStyle.buttonStyle}
          variant="contained"
          color="primary"
          disabled={!props.buttonEnable}
          disableElevation
          onClick={(e) => {
            props.onClickDelButton();
          }}
        >
          {t('ConanairManagementFooter.削除', '削除')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default ConanairManagementFooter;